import { BaseSupabaseService } from './BaseSupabaseService';
import config from '../config/environment';
import { ParQData, SubmitParQPayload } from '../types';
import { handleServiceError } from '../utils/errorHandler';

class ParQServiceClass extends BaseSupabaseService<ParQData> {
  constructor() {
    super('parq');
  }

  async findByStudentId(studentId: number): Promise<ParQData | null> {
    const results = await this.findAll({
      filters: [{ column: 'student_id', value: studentId }],
    });
    return results[0] || null;
  }

  async upsertForStudent(studentId: number, data: Partial<ParQData>): Promise<ParQData> {
    const existing = await this.findByStudentId(studentId);
    if (existing) {
      return this.update(existing.id, data);
    }
    return this.create({ ...data, student_id: studentId });
  }

  async submitRegistration(payload: SubmitParQPayload): Promise<void> {
    if (!config.supabaseFunctionsUrl) {
      handleServiceError(new Error('URL das Edge Functions não configurada.'), 'enviar PAR-Q');
    }

    try {
      const response = await fetch(`${config.supabaseFunctionsUrl}/submit-parq`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          apikey: config.supabaseAnonKey,
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorPayload = await response.json().catch(() => ({}));
        handleServiceError(new Error(errorPayload?.error || 'Erro ao enviar PAR-Q'), 'enviar PAR-Q');
      }
    } catch (error: unknown) {
      handleServiceError(error, 'enviar PAR-Q');
    }
  }
}

export const ParQService = new ParQServiceClass();
